import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function FAQLinks({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
   
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p>links that may assist with this process.</p>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <span className="onclick-text">codebox login</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Del City Inpsection</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">keys</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">lockbox codes</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">mileage tracking</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Mold</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Photo storage old photos</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">nested tour photos</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">property inspections</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">property listing</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">
                  Guest Cards/Property showings
                </span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Utilities</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Vacant property steps</span>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default FAQLinks;
